<template lang="">
  <div :class="style.answer">
    <div v-for="(list, title) in data" :class="style.answerList">
      <div v-show="item.checked" v-for="item in list" :class="style.itemAnswer">
        <p>
          <span v-text="title + ': '" />
          <span v-if="item.checked" v-text="item.title" />
        </p>
        <span v-if="item.checked" :class="style.cost" v-text="item.cost" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import style from "./Answer.module.scss";
export default defineComponent({
  name: "AnswerSeagull",
  props: ["data"],
  data() {
    return {
      style
    };
  }
});
</script>
